import {getMockSearchFull} from '../get-item-list/api-mocks/apigee-response';
import {fetchService} from '../index';
import type {SearchSuggestions} from './types';

export async function searchQuery(
  query: string,
  start: number,
  rows: number,
  language: string,
  layoutId?: string,
) {
  const path = '/search/full';
  const queryParams: any = {
    query,
    start,
    rows,
    searchLanguage: language,
  };
  if (layoutId) {
    queryParams['layoutId'] = layoutId;
  }
  //mocking for git push pre-hook for local environment pnpm run build
  if (
    process?.env?.TARGET_ENV === 'local' ||
    process?.env?.TARGET_ENV === 'work'
  ) {
    return rows === 10
      ? getMockSearchFull('breadCrumb')
      : getMockSearchFull('related-items');
  }

  const data = await fetchService(path, 'GET', queryParams, null, null);
  return data;
}

export async function searchSuggestions(
  query: string,
  start: number,
  rows: number,
  language: string,
) {
  const path = '/search/suggest';
  const queryParams = {
    query,
    start,
    rows,
    searchLanguage: language,
  };
  const data: SearchSuggestions = await fetchService(
    path,
    'GET',
    queryParams,
    null,
    null,
  );
  return data;
}
